import { MantineThemeOverride, MantineThemeColorsOverride } from "@mantine/core"

import { colors } from "./colors"
import { FONT_FAMILY } from "./font"

export const theme: MantineThemeOverride = {
  // Colors
  colors: colors as MantineThemeColorsOverride,
  primaryColor: "primary",
  black: colors.gray[9],

  // Font Family
  fontFamily: FONT_FAMILY,

  // Components
  components: {
    Text: {
      defaultProps: {
        size: "md",
      },
    },

    Paper: {
      defaultProps: {
        p: "xl",
        radius: "md",
        bg: "surfaceCard",
        shadow: "sm",
        styles: {
          root: {
            border: "none",
          },
        },
      },
    },

    Button: {
      defaultProps: {
        radius: "md",
      },
      styles: {
        root: {
          fontWeight: 500,
        },
      },
    },

    ActionIcon: {
      defaultProps: {
        variant: "transparent",
        radius: "md",
      },
    },

    ThemeIcon: {
      defaultProps: {
        variant: "transparent",
        radius: "md",
        size: "lg",
      },
    },

    Select: {
      defaultProps: {
        radius: "md",
        size: "sm",
      },
    },

    TextInput: {
      defaultProps: {
        radius: "md",
        size: "sm",
      },
    },

    Input: {
      defaultProps: {
        radius: "md",
        size: "sm",
      },
    },

    Loader: {
      defaultProps: {
        type: "bars",
      },
    },
  },
}
